import { deleteModal } from './deleteModalSlice';
import { Action } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import { ThunkDispatch } from 'redux-thunk';
import { useState } from 'react';
import { IInitialSliceState } from '../../common/types/commonTypes';
import useNotification from '../notification/useNotification'
import { useSpinner } from '../../customHooks';
import { groupList } from '../../pages/deviceManagement/groupSlice';
import { isSuccessResponse } from '../../common/utils';
import { IDeleteGroupPayload } from '../../common/types/groupTypes';

interface IDeleteGroupResponseState {
    deleteModal: IInitialSliceState
}

export const useDeleteModal = () => {
    const dispatch: ThunkDispatch<IDeleteGroupResponseState, undefined, Action> = useDispatch();
    const deleteGroupResponse = useSelector((state: IDeleteGroupResponseState) => state.deleteModal);
    const [groupOrgId, setGroupOrgId] = useState<string>('');
    const [showModel, setShowModel] = useState(false);

    useSpinner(deleteGroupResponse.status);
    const setPayload = () => {
        const deleteGroupPayload: IDeleteGroupPayload = {
            orgId: groupOrgId
        };
        return deleteGroupPayload;
    }
    const { showSuccessNotification, showWarningNotification } = useNotification();
    const handleDeleteButtonClick = () => {
        const deleteOrgPayload = setPayload();
        dispatch(deleteModal(deleteOrgPayload)).then((response: any) => {
            if (isSuccessResponse(response.payload)) {
              dispatch(groupList());
              showSuccessNotification(response.payload.message);
            }
            else {
              showWarningNotification(response.payload.response.data.message);
            }
          });
        setShowModel(false);
        setGroupOrgId('');
    };

    return {
        handleDeleteButtonClick,
        showModel,
        setShowModel,
        setGroupOrgId
    };
}